import { render, staticRenderFns } from "./products_page.vue?vue&type=template&id=54fa5f3e&"
import script from "./products_page.vue?vue&type=script&lang=js&"
export * from "./products_page.vue?vue&type=script&lang=js&"
import style0 from "./products_page.vue?vue&type=style&index=0&id=54fa5f3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports